/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  updateBodyClassOnScroll();

  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', initCalendly);
  else initCalendly();

  productInquireForm();


  // Add helper classes to the body when scrolling up/down or at the top of the page
  function updateBodyClassOnScroll() {
    let lastScrollY = window.scrollY;
    const headerGroup = document.querySelector(".header-sections");
    let headerHeight = getHeaderHeight();
    console.log("header height", headerHeight);
    window.addEventListener('scroll', updateClasses);
    if (window.scrollY === 0) {
      document.body.classList.add('at-top');
    }
    document.body.classList.toggle('header-outof-view', window.scrollY > headerHeight);
    window.addEventListener("resize", updateHeaderHeight);


    function updateClasses(e) {
      const currentScrollY = window.scrollY;
      const bodyElement = document.body;
      // Scrolled down
      if (currentScrollY > lastScrollY && currentScrollY > 0) {
        bodyElement.classList.add('scrolled-down');
        bodyElement.classList.remove('scrolled-up');
        bodyElement.classList.remove('at-top');
      } 
      // Scrolled up
      else if (currentScrollY < lastScrollY) {
        bodyElement.classList.add('scrolled-up');
        bodyElement.classList.remove('scrolled-down');
        bodyElement.classList.remove('at-top');
      } 
      // At top
      else if (currentScrollY === 0) {
        bodyElement.classList.add('at-top');
        bodyElement.classList.remove('scrolled-down');
        bodyElement.classList.remove('scrolled-up');
      }

      document.body.classList.toggle('header-outof-view', window.scrollY > headerHeight);

      lastScrollY = currentScrollY;
    }
    function getHeaderHeight() {
      let height = 0;
      if (headerGroup) height = headerGroup.offsetHeight;

      return height;
    }
    function updateHeaderHeight() {
      headerHeight = getHeaderHeight();
      console.log("header height updated", headerHeight);
    }
  }


  /*
   * Calendly Scheduler setup
   * - To use with Calendly Inline text pop-up embed code
   * - any link with href="#calendly" will trigger scheduler popup to display
   * - ex: <a href="#calendly">Schedule Appointment</a>
   * - To update the embed code go to Theme Editor -> Theme Options -> Calendly tab
   * - ensure there is a link included in the embed code "<a href="" onclick="Calendly.initPopupWidget({url:..."
   * - the embed code is outputed in the "theme.liquid" file at the bottom
  */
  function initCalendly() {
    const embedCodeContainer = document.getElementById("calendly-embed-code");
    if (!embedCodeContainer) return console.log("No Calendly embed code found");
    const calendlyLink = document.querySelectorAll("a[href*='#calendly']");
    const embedCodeTrigger = embedCodeContainer.querySelector("a");
    if (!embedCodeTrigger) return console.warn("No embed code trigger found!", embedCodeContainer);

    calendlyLink.forEach(initCalendlyLink);

    function initCalendlyLink(trigger) {
      trigger.addEventListener("click", function(e) {
        e.preventDefault();
        embedCodeTrigger.click();
      });
    }
  }


  /*
  * Inquiry Popup Form - Product Pages 
  *
  */
  function productInquireForm() {
    const body = document.querySelector("body");
    if (!body.classList.contains("template-product")) return;
    const inquireBtn = document.querySelector(".js-inquire");
    const contactModal = document.getElementById("product-inquire-form");
    if (!contactModal) return console.warn("no contact modal found!");
    const productTitle = contactModal.dataset.product;
    const messageField = contactModal.querySelector("[name='contact[message]'");
    const productForm = document.querySelector("product-form");
    const selectedProductID = productForm.querySelector('[name="product-id"]');
    if (!selectedProductID) return console.warn("No selected product id found!", productForm);
    const url = document.location.origin + document.location.pathname;

    document.addEventListener("DOMContentLoaded", setupContactModal);
    inquireBtn.addEventListener("click", openContact);
    contactModal.addEventListener("click", closeContact);
    contactModal.querySelector(".inquire-contact").addEventListener("click", stopProp);
    

    function openContact(e) {console.log("openContact");
      //if (!inquireBtn.classList.contains("disabled") && e) return;
      if (e) e.preventDefault();//console.log("clicked");
      addMessage();
      body.classList.add("contact-form-active");
    }
    function closeContact(e) {
      if (e) e.preventDefault();
      body.classList.remove("contact-form-active");
    }
    function stopProp(e) {
      e.stopPropagation();
    }
    function setupContactModal() {
      body.append(contactModal);
      addMessage();
      if (contactModal.querySelector(".inquire-form-errors") || contactModal.querySelector(".form__message")) openContact();
      //if (contactModal.querySelector(".form__message")) contactModal.querySelector("header.contact__head").style.display = "none";
    }
    function addMessage() {
      messageField.textContent = "Hello, \n\nI am interested in " + productTitle + ".\n\n " + url + "?variant=" + selectedProductID.value;
    }
  }
})();


(function () {
  
  
})();